Element.prototype._attachShadow = Element.prototype.attachShadow;
Element.prototype.attachShadow = function () {
    return this._attachShadow({ mode: "open" });
};

/*
 * Focus Trap helpers
 */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  first.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let t = false;
  return (...args) => {
    if (!t) {
      fn.apply(this, args)
      t = true;
      setTimeout(() => t = false, wait)
    }
  }
}

function handleize(str) {
  str = str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .replace(/([^\w]+|\s+)/g, "-") // Replace space and other characters by hyphen
    .replace(/\-\-+/g, "-") // Replaces multiple hyphens by one hyphen
    .replace(/(^-+|-+$)/g, "") // Remove extra hyphens from beginning or end of the string
    .toLowerCase(); // To lowercase

  return str;
}

/*
 * Woolman Common JS
 */

// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}

Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// -------
// Load components / libraries
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  Woolman.DetailsAccordions.init();
  Woolman.CustomSelect.init();
  Woolman.Discounts.init();
  Woolman.Onetrust();
  Woolman.VWO();

  function hideWalletButtonsIfPresent() {
    // Access all shopify accelerated checkout carts in the drawer
    document.querySelectorAll('.drawer shopify-accelerated-checkout-cart').forEach(cartContainer => {
      const shadowRoot = cartContainer.shadowRoot;
      
      // Ensure the shadow root is available
      if (!shadowRoot) return;
  
      // Search for all wallet cart button containers
      shadowRoot.querySelectorAll('.wallet-cart-button-container').forEach(buttonContainer => {
        const shopPaySlot = buttonContainer.querySelector('slot[name="button-ShopPay"]');
        const googlePaySlot = buttonContainer.querySelector('slot[name="button-GooglePay"]');
        
        // If either Shop Pay or Google Pay slot is present, hide the button container
        if (shopPaySlot || googlePaySlot) {
          buttonContainer.style.display = 'none';  // Hide the container
        }
      });
    });
  }
  
  const mutationObserver = new MutationObserver(hideWalletButtonsIfPresent);
  
  // Target the cart drawer to observe any child element changes
  const cartDrawer = document.querySelector('drawer-cart');
  if (cartDrawer) {
    mutationObserver.observe(cartDrawer, { childList: true, subtree: true });
  }

  // ---- UTM handler for anchor links ----
  document.querySelectorAll('a[href^="#"][data-utm]').forEach(anchor => {
    anchor.addEventListener('click', function (event) {
      const href = anchor.getAttribute('href'); // e.g. #section
      const utm = anchor.getAttribute('data-utm'); // e.g. ?utm_source=...

      const currentUrl = new URL(window.location.href);
      const currentSearchParams = currentUrl.searchParams;

      // Parse new UTM params
      const utmParams = new URLSearchParams(utm.replace(/^\?/, '')); // remove leading "?" if present
      for (const [key, value] of utmParams.entries()) {
        if (!currentSearchParams.has(key)) {
          currentSearchParams.append(key, value); // only add if not already present
        }
      }

      // Build updated URL
      const newUrl =
        currentUrl.pathname +
        '?' +
        currentSearchParams.toString() +
        href;

      history.replaceState(null, '', newUrl); // update without reload

      // Smooth scroll
      const target = document.querySelector(href);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

   // Attach theme editor listeners
   if (!Shopify || !Shopify.designMode) return;

  let lastSelection = {
    sectionId: undefined,
    blockId: undefined
  };

  // Load is called when something is changed within section settings
  document.addEventListener('shopify:section:load', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    if (sectionId === Woolman.Header.cache.section.id) {
      Woolman.ModalsAndDrawers.init();
      Woolman.Header.init();
    }

    if (document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('shopify:section:load sectionId', evt.detail.sectionId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:block:select', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    const blocks = document.getElementById(sectionId).querySelectorAll('[data-shopify-editor-block]')
    const selectedBlock = [...blocks].find(x => JSON.parse(x.dataset.shopifyEditorBlock).id === evt.detail.blockId);
    if (sectionId === Woolman.Header.cache.section.id) {
      if (selectedBlock) {
        // Make sure menu is open
        Woolman.Header.cache.openButton.click();

        // Select menu item
        const accordion = selectedBlock.closest('[data-accordion-item]').querySelector('input');
        const label = selectedBlock.closest('[data-accordion-item]').querySelector('label');
        if (!accordion.checked) label.click();
      }
    } else if (sectionId.includes('modal') && document.getElementById(sectionId).querySelector('[data-modal]')) {
      if (selectedBlock) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(document.getElementById(sectionId).querySelector('[data-modal]').id);
      }
    } else if (sectionId.includes('image-with-hotspots') && document.getElementById(sectionId).querySelector('.swatches')) {
      if (selectedBlock) {
        const variantName = selectedBlock.getAttribute('data-variant-name');
        const swatch = document.getElementById(sectionId).querySelector(`.swatches [data-variant-name="${variantName}"]`);
        if (swatch) {
          swatch.click();
        }
      }
    }

    lastSelection.sectionId = evt.detail.sectionId;
    lastSelection.blockId = evt.detail.blockId;
    console.log('shopify:block:select', evt.detail.sectionId, evt.detail.blockId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:unload', (evt) => {
    console.log('shopify:section:unload sectionId', evt.detail.sectionId)
  })

  document.addEventListener('shopify:section:select', (evt) => {
    console.log('shopify:section:select', evt.detail.sectionId)
    lastSelection = {
      sectionId: evt.detail.sectionId,
      blockId: evt.detail.blockId
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:deselect', (evt) => {
    console.log('shopify:section:deselect', evt.detail.sectionId)
    lastSelection = {
      sectionId: undefined,
      blockId: undefined
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })
};

// -------
// Woolman Common JS - Utility library
Woolman.Utils = {
  debugMode: true,
  prepareQueryParams: () => {
    Shopify.queryParams = Shopify.queryParams || {};

    // Preserve existing query parameters
    if (location.search.length) {
      const params = location.search.substr(1).split('&');
      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=');
        // Spaces are reverted back after the decode, since in component-facets.js we'll use URLSearchParams() method and we don't want to double decode the spaces
        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]).replaceAll('+', ' ');
        }
      }
    }

    return Shopify.queryParams;
  },
  formatMoney(cents, format, ignoreRate = false) {
    const default_money_format = theme.settings.moneyFormat || '€{{amount}}';

    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    if (window?.Shopify?.currency?.rate && ignoreRate !== true) {
      cents = cents * parseFloat(window.Shopify.currency.rate || 1.0);
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
};

Woolman.CustomSelect = {
  init: () => {
    document.querySelectorAll('[data-custom-select]').forEach(select => {
      Woolman.CustomSelect.initSingleSelect(select);
    });
  },
  
  initSingleSelect: (select) => {
    EasySelect.init(`#${select.id}`, {
      align: select.dataset.align ?? 'left',
      closeOnChange: select.dataset.closeOnChange === 'false' ? false : true,
      onInit: data => {
        document.dispatchEvent(new CustomEvent(`estrid:custom-select-init.${select.id}`));

        // if (!data.instance.originalSelectTag.dataset.customSelectLabel) {
        //   return;
        // }

        // data.instance.current.dataset.label = data.instance.originalSelectTag.dataset.customSelectLabel;

        if (data.instance.originalSelectTag.dataset.customSelectLabel) {
          data.instance.current.dataset.label = data.instance.originalSelectTag.dataset.customSelectLabel;
        }

        updateCleanLabel(data.instance);
      },
      onChange: data => {
        data.instance.originalSelectTag.value = data.value;
        data.instance.originalSelectTag.dispatchEvent(new Event('change'));
        updateCleanLabel(data.instance);
      },
      customDropDownOptionHTML: option => {
        let html = option.innerHTML;

        if (select.id.includes('frequency-select-single')) {
          const sellingPlanSubtitle = option.el.getAttribute('data-selling-plan-subtitle');
          const isMostPopular = option.el.getAttribute('data-is-most-popular') === 'true';
          const isFreeTrial = select.dataset.isFreeTrial === 'true';

          html = `
            <div class="flex space-between center-center es-option__frequency gap-8">
              <div class="flex vertical text-align-left">
                ${!isFreeTrial ? `
                  <div class="badges mb-8">
                    <div class="badge badge--default badge--free-shipping">${window.themeStrings.free_shipping}</div>
                  </div>
                ` : ''}
                <em>${option.label}</em>
                <div class="mt-8 color-secondary-text">
                  <p data-selling-plan-subtitle>${sellingPlanSubtitle}</p>
                </div>
              </div>
              
              ${isMostPopular ? `
                <div class="flex center-center">
                  <div class="badge badge--default">${window.themeStrings.most_popular}</div>
                </div>
              ` : ''}
            </div>
          `
        } else if (select.id.includes('frequency-select-pdp')) {
          const isMostPopular = option.el.getAttribute('data-is-most-popular') === 'true';
          html = `
            <div class="flex space-between center-center es-option__frequency gap-8">
              <div class="flex vertical text-align-left">
                ${option.label}
              </div>
              
              ${isMostPopular ? `
                <div class="flex center-center">
                  <div class="badge badge--default">${window.themeStrings.most_popular}</div>
                </div>
              ` : ''}
            </div>`
        } else if (select.id == 'frequency-select-offer') {
          const isMostPopular = option.el.getAttribute('data-is-most-popular') === 'true';

          html = `
            <div class="flex space-between center-center es-option__frequency gap-8">
              <div class="flex vertical text-align-left">${option.label}
              </div>
              
              ${isMostPopular ? `
                <div class="flex center-center">
                  <div class="badge badge--default">${window.themeStrings.most_popular}</div>
                </div>
              ` : ''}
            </div>
          `
        } else {
          const optionValue = option.el.getAttribute('value');
          const customHtml = document.querySelector(`[data-custom-select-html-id=${select.id}] [data-option-value="${optionValue}"]`)?.outerHTML;

          if (customHtml) {
            html = customHtml;
          }
        }

        return html;
      }
    });

    // Function for remove the "Most Popular Badge" from the frequency selector for selected options 
    function updateCleanLabel(instance) {
      const selectedOption = select.options[select.selectedIndex];
      const cleanLabel = cleanLabelText(selectedOption?.dataset.label || selectedOption?.text || '');
      const currentOption = instance.wrapper.querySelector('.es-current .es-option');

      if (cleanLabel && currentOption) {
        currentOption.innerHTML = `<span>${cleanLabel}</span>`;
      }
    }

    function cleanLabelText(label) {
      return label.replace(/\s*\(.*Most popular.*\)/i, '').trim();
    }
  }
}

// -------
// Woolman Common JS - Header component
Woolman.Header = {
  selectors: {
    header: 'MainHeader',
    cartBlip: '.cart-blip'
  },
  cache: {
    header: undefined,
    cartBlip: undefined,
    section: undefined,
    openButton: undefined
  },

  init: function () {
    this.cache.header = document.getElementById(this.selectors.header);
    this.cache.cartBlip = this.cache.header.querySelector(this.selectors.cartBlip);
    this.cache.section = this.cache.header.closest('.shopify-section');
    this.cache.openButton = this.cache.header.querySelector('[href="#drawer-menu"]');

    // Check if the first section is a slideshow and the first slide has data-header-style="light"
    const mainDiv = document.querySelector('main');
    let firstSectionIsSlideshow = false;

    const firstSection = mainDiv ? mainDiv.querySelector('.shopify-section') : null;
    if (firstSection && firstSection.id.includes('slideshow')) {
      firstSectionIsSlideshow = true;
      const firstSlide = firstSection.querySelector('.gridy-track') ? firstSection.querySelector('.gridy-track').firstElementChild : null;
      // const firstSlide = firstSection.querySelector('.gridy-track').firstElementChild; //here11
      if (firstSlide && firstSlide.getAttribute('data-header-style') === 'light') {
        this.cache.header.classList.add('header--light');
      }
    } else if (firstSection && firstSection.id.includes('hero') && firstSection.querySelector('.hero').getAttribute('data-header-style') === 'light') {
      this.cache.header.classList.add('header--light');
    }

    // Update cart blip when product is added to cart.
    document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this))
    document.addEventListener('cart:update', this.updateCartBlip.bind(this));

    // Listen for slide change events
    if (firstSectionIsSlideshow) {
      document.addEventListener('gridy-slider:slide-change', this.onSlideChange.bind(this));
    }

    if (this.cache.header.dataset.stickyBehavior === 'none') return;
    this.initStickyBehavior(this.cache.header.dataset.stickyBehavior)
  },

  onSlideChange(event) {
    const { slideElement } = event.detail;

    if (slideElement.getAttribute('data-header-style') == 'light') {
      this.cache.header.classList.add('header--light');
    } else {
      this.cache.header.classList.remove('header--light');
    }
  },

  initStickyBehavior(behaviorType) {
    const stickyConfig = {
      headerHeight: this.cache.header.clientHeight,
      behavior: behaviorType
    }

    document.documentElement.classList.add('sticky-header-initialized', `sticky-header-${behaviorType}`);
    document.documentElement.style.setProperty('--sticky-header-margin-top', `${stickyConfig.headerHeight}px`);

    if (behaviorType === 'scroll' || behaviorType === 'fixed') {
      // Show on scroll fixed header
      let prevScroll = window.scrollY || document.documentElement.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      const toggleStickyHeader = (direction, curScroll) => {
        if (direction === 1) {
          document.documentElement.classList.remove('sticky-header-hide')
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide')
        }

        prevDirection = direction;
      }

      window.addEventListener('scroll', throttle(() => {
        curScroll = window.scrollY || document.documentElement.scrollTop;

        if (curScroll >= 300) {
          document.documentElement.classList.add('sticky-header-show')
        } else {
          document.documentElement.classList.remove('sticky-header-show');
        }

        if (curScroll > prevScroll) {
          direction = 2; // user scrolling down
        } else {
          direction = 1; // user scrolling up
        }

        if (direction !== prevDirection && behaviorType === 'scroll') {
          toggleStickyHeader(direction, curScroll)
        }

        prevScroll = curScroll
      }, 50))

      setInterval(() => {
        if (direction === 2 && behaviorType === 'scroll' && curScroll >= 900) {
          toggleStickyHeader(direction, curScroll);
        }
        if (window.scrollY === 0) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide');
        }
      }, 200)
    }
  },

  async updateCartBlip(e) {
    const cart = e.detail && e.detail.cart && e.detail.cart.item_count || await (async function () {
      const res = await fetch('/cart.json');
      const cart = await res.json();
      return cart;
    })();

    this.cache.cartBlip.textContent = cart.item_count || 0;
    if (cart && cart.item_count == 0) {
      this.cache.cartBlip.setAttribute('hidden', true);
      this.cache.cartBlip.closest('.header-item__link').classList.remove('has-blip-visible');
    } else {
      this.cache.cartBlip.removeAttribute('hidden')
      this.cache.cartBlip.closest('.header-item__link').classList.add('has-blip-visible');
    }
    
    // update progress bar when subscribe product on cart drawer
    updateShippingProgress(cart);
  }
};

// -------
// Woolman Common JS - Modals & drawers library
Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'a[href*="#modal"]:not(.quick-buy__link)',
      drawerLink: 'a[href*="#drawer"]',
    },
  },
  focusTraps: {},
  init: function () {
    // Init open event listeners
    document.querySelectorAll(this.settings.selectors.modalLink).forEach((modalLink) => {
      modalLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        const slideIndex = event.currentTarget.getAttribute('href').substring(1).split('?slide=')[1];
        const scrollToId = event.currentTarget.getAttribute('href').substring(1).split('?scroll=')[1];
        
        if (targetId != 'modal-geo') {
          this.showModalOrDrawer(targetId, parseInt(slideIndex), scrollToId);
        }
      });
    });

    document.querySelectorAll(this.settings.selectors.drawerLink).forEach((drawerLink) => {
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        this.showModalOrDrawer(targetId);
      });
    });

    // Init close event listeners
    const closeBtns = document.querySelectorAll('[data-close]');
    if (closeBtns) {
      closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    const overlays = document.querySelectorAll('[data-overlay]');
    if (overlays) {
      overlays.forEach((overlay) => {
        overlay.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    // Escape to close all
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        document.querySelectorAll('.drawer').forEach((drawer) => {
          drawer.classList.remove('is-open');
        });
        document.querySelectorAll('.modal').forEach((modal) => {
          modal.classList.remove('is-open');
        });
        document.body.classList.remove('overflow-hidden');
      }
    });
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * @param {int} slideIndex - Index of a Gridy Slider slide inside the opened modal - (sliding motion)
   * @param {string} scrollToId - ID of a Gridy Slider slide inside the opened modal - (no motion)
   * Traps focus to modal and disables body scrolling.
   */
  showModalOrDrawer: function (targetId, slideIndex, scrollToId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }

    // changes specific to subscription upgrade box
    if (targetId === "drawer-cart") {
      // init event to show "subscription upgrade boxes" & hide "subscription upgrade undo boxes"
      const subscriptionEvent = new CustomEvent("estrid:show-conditionally-subscription-upgrade-box");
      // trigger event
      document.dispatchEvent(subscriptionEvent);
      
      const upsellEvent = new CustomEvent("estrid:show-conditionally-upsell-bundle-upgrade-box", {});
      document.dispatchEvent(upsellEvent);
    }

    if (targetElement.classList.contains('is-open')) return;

    targetElement.classList.add('initialized', 'is-open');
    document.body.classList.add('overflow-hidden');
    

    setTimeout(() => {
      trapFocus(targetElement);
    }, 600);

    if (slideIndex) {
      setTimeout(() => {
        const gridySlider = targetElement.querySelector('gridy-slider');
        gridySlider.scrollToSlide(slideIndex - 1);
      }, 600);
    } else if (scrollToId) {
      const scrollToElement = document.getElementById(scrollToId),
            modal_dialog = targetElement.querySelector('.gridy-track');

      modal_dialog.scrollTo({
        top: scrollToElement.offsetTop,
        left: scrollToElement.offsetLeft,
        behavior: "instant"
      });
    }

    document.dispatchEvent(new CustomEvent(`drawerOrModalOpen.${targetId}`));
  },
  closeModalOrDrawer: function(targetId) {
    const targetElement = document.getElementById(targetId);
    targetElement.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');

    document.dispatchEvent(new CustomEvent(`drawerOrModalClose.${targetId}`));
  },
  closeModalOrDrawerOrDrawerFromEvent: function (event) {
    event.preventDefault();
    removeTrapFocus();
    const parentElement = event.currentTarget.closest('[data-parent]');
    const targetId = parentElement.getAttribute('id');
    parentElement.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');

    document.dispatchEvent(new CustomEvent(`drawerOrModalClose.${targetId}`));
  },

  closeAll: function() {
    document.querySelectorAll('.drawer').forEach((drawer) => {
      drawer.classList.remove('is-open');
      document.dispatchEvent(new CustomEvent(`drawerOrModalClose.${drawer.id}`));
    });
    document.querySelectorAll('.modal').forEach((modal) => {
      modal.classList.remove('is-open');
      document.dispatchEvent(new CustomEvent(`drawerOrModalClose.${modal.id}`));
    });
    document.body.classList.remove('overflow-hidden');
  },
};

/**
 * Allow us to trigger something when window is actually resized.
 */
let woolman_window_size = window.innerWidth;
window.addEventListener(
  'resize',
  debounce(() => {
    if (window.innerWidth == woolman_window_size) {
      return;
    }
    woolman_window_size = window.innerWidth;
    document.dispatchEvent(new CustomEvent('estrid:resize'));
  }),
  250
);

/**
 * Animated details element
 */
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.initialSummaryHeight = el.querySelector('summary').offsetHeight;
    this.content = el.querySelector('.content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
    this.toggleByViewport();
    document.addEventListener('estrid:resize', this.toggleByViewport.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.initialSummaryHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-in-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }

  toggleByViewport() {
    let mobileClose = this.el.dataset.mobileClose != undefined ? JSON.parse(this.el.dataset.mobileClose) : false;
    let desktopOpen = this.el.dataset.desktopOpen != undefined ? JSON.parse(this.el.dataset.desktopOpen) : false;

    if (woolman_window_size >= 768 && desktopOpen) {
      this.el.open = true;
    } else if (mobileClose) {
      this.el.open = false;
    }
  }
};

Woolman.DetailsAccordions = {
  init: function () {
    document.querySelectorAll('details').forEach((el) => {
      new Accordion(el);
    });
  }
};

Woolman.Discounts = {
  init() {
    const urlParams = new URLSearchParams(window.location.search);
    const discountCode = urlParams.get('discount');

    if (discountCode) {
      if (theme.settings.customDiscountList && theme.settings.customDiscountList.includes(discountCode)) {
        window.Toastify({
          text: window.cartStrings.discount_code_applied
        }).showToast();
        
        this.updateCart(discountCode);
        this.removeDiscountFromUrl();

        const event = new CustomEvent('estrid:discount-applied');
        document.dispatchEvent(event);
      } else {
        document.cookie = `discount_code=${discountCode}; path=/`;

        this.applyDiscount(discountCode)
          .then(() => {
            this.updateCart(discountCode);
            this.removeDiscountFromUrl();
          })
          .catch(error => console.error('Error applying discount:', error));
      }
    }
  },

  async applyDiscount(discountCode) {
    const rootUrl = window.routes.root === '/' ? '/' : `${window.routes.root}/`;

    try {
      const response = await fetch(`${rootUrl}discount/${discountCode}`);

      if (!response.ok) {
        throw new Error('Failed to apply discount');
      }
    } catch (error) {
      console.error('Error applying discount:', error);
      throw error;
    }
  },

  async updateCart(discountCode) {
    const rootUrl = window.routes.root === '/' ? '/' : `${window.routes.root}/`;
  
    try {
      const response = await fetch(`${rootUrl}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {},
          attributes: {
            discount_code: discountCode
          }
        }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to update cart');
      }
  
      const cartData = await response.json();
  
      // Check if the discount is applied at the cart level
      const cartLevelDiscountApplied = cartData.cart_level_discount_applications?.some(
        (discount) => discount.code === discountCode
      );
  
      // Check if the discount is applied at the item level
      const itemLevelDiscountApplied = cartData.items.some(item =>
        item.discounts.some(discount => discount.title === discountCode)
      );
  
      const discountApplied = cartLevelDiscountApplied || itemLevelDiscountApplied;
  
      if (discountApplied) {
        const event = new CustomEvent('estrid:discount-applied');
        document.dispatchEvent(event);
  
        window.Toastify({
          text: window.cartStrings.discount_code_applied
        }).showToast();
      }
  
      return discountApplied; // Return whether the discount is applied
    } catch (error) {
      console.error('Error updating cart:', error);
      return false;
    }
  },

  removeDiscountFromUrl() {
    const url = new URL(window.location);
    url.searchParams.delete('discount');
    window.history.replaceState({}, document.title, url.toString());
  }
};

Woolman.Onetrust = function () {
  const OneTrustButtons = document.querySelectorAll('[data-onetrust-open-banner]');
  const language = document.documentElement.lang || 'en';

  function initializeOneTrust() {
    function checkOneTrust() {
      const maxAttempts = 50; // Maximum number of attempts
      let attempts = 0;
  
      const intervalId = setInterval(() => {
        if (window.OneTrust) {
          document.dispatchEvent(new Event('OneTrustLoaded'));
  
          clearInterval(intervalId); // Stop checking once OneTrust is available
        } else if (attempts >= maxAttempts) {
          clearInterval(intervalId); // Stop checking after max attempts
        }
        attempts++;
      }, 100); // Check every 100ms
    }

    checkOneTrust();
  }
  
  // Initialize OneTrust
  initializeOneTrust();
  
  // Listen for the custom event
  document.addEventListener('OneTrustLoaded', () => {
    const language = document.documentElement.lang || 'en';

    window.OneTrust.changeLanguage(language);
  });

  OneTrustButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
        window.OneTrust.ToggleInfoDisplay();
      }
    });
  });
}

Woolman.VWO = function () {
  // Initialize VWO object if it doesn't exist
  window.VWO = window.VWO || [];

  // Define the init function if it doesn't exist
  window.VWO.init = window.VWO.init || function(state) {
    window.VWO.consentState = state;
  };

  // Function to handle consent changes
  function handleConsentChange() {
    // Access consent categories from OneTrust
    const consentCategories = window.OnetrustActiveGroups || '';

    if (consentCategories.includes('C0002')) {
      window.VWO.init(1); // Consent granted
    } else if (consentCategories.includes('C0003')) {
      window.VWO.init(2); // Consent pending
    } else {
      window.VWO.init(3); // Consent denied
    }
  }

  // Function to check for OneTrust availability
  function checkOneTrust() {
    const maxAttempts = 50; // Maximum number of attempts
    let attempts = 0;

    const intervalId = setInterval(() => {
      if (window.OneTrust && typeof OneTrust.OnConsentChanged === 'function') {
        OneTrust.OnConsentChanged(handleConsentChange);
        clearInterval(intervalId); // Stop checking once OneTrust is available
      } else if (attempts >= maxAttempts) {
        clearInterval(intervalId); // Stop checking after max attempts
      }
      attempts++;
    }, 100); // Check every 100ms
  }

  // Start checking for OneTrust
  checkOneTrust();
}

Woolman.init();

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      form: this.querySelector('form'),
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('form button[type="submit"]') || this.querySelector('button[type="submit"]'),
      select: this.querySelector('select'),
    };

    if (this.elements.form) {
      this.elements.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    if (this.elements.select) {
      this.elements.select.addEventListener('change', this.onItemClick.bind(this));
    }

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    if (!this.elements.input) return;

    this.elements.input.value = event.currentTarget.dataset.value;

    // Filter params fix, replace "%2C" with ","
    const returnToInput = this.elements.form.querySelector('[name="return_to"]');
    if (returnToInput) {
      let return_to_value = returnToInput.value;
      let indexOfFilters = return_to_value.indexOf("?filter");
      if (indexOfFilters !== -1) {
        let substringAfterFilters = return_to_value.substring(indexOfFilters);
        let replacedSubstring = substringAfterFilters.replace(/%2C/g, ",");
        returnToInput.value = return_to_value.substring(0, indexOfFilters) + replacedSubstring;
      }
    }

    if (!this.elements.button) {
      const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      this.elements.form.dispatchEvent(submitEvent);
    }
  }

  onSubmit() {
    // SHOP-563: Use cookie-based storage instead of localStorage
    if (window.LocaleResolver?.Utils) {
      const inputName = this.elements.input ? this.elements.input.name : '';

      if (inputName !== 'locale_code') {
        const selectedCountry = this.elements.select ? this.elements.select.value : this.elements.input.value;
        
        // SHOP-563 BUG FIX: Intelligently preserve locale when switching countries
        const currentLocale = window.Shopify?.locale || 'en';
        const selectedLocale = LocaleResolver.Utils.getLocaleForCountry(selectedCountry, currentLocale);
        
        // Save to cookie with 13-month TTL
        LocaleResolver.Utils.setLocaleCookie(selectedLocale, selectedCountry);
        
        // Always add locale code to form
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'locale_code';
        hiddenInput.value = selectedLocale;
        this.elements.form.appendChild(hiddenInput);
      }
    }

    this.elements.form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

// Custom element that enhances HTML Video Element functionality.
// Usage: <video is="superpowered-video">
class SuperPoweredVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video') || this.querySelector('iframe');
    this.container = this.closest('.video-container') || null;

    if (this.container) this.attachClickListener(this.closest('.video-container'));

    // check if video is iframe and has a src and that src is youtube
    if (this.video.nodeName === 'IFRAME' && this.video.src && this.video.src.includes('youtube') && !this.container) {
      this.video.addEventListener('load', this.onVideoLoad.bind(this));
    }

    // When video is out of viewport pause it. This is to prevent videos from playing in the background.
    // If video is in viewport play it.
    // Use: Intersection Observer API
    const autoplay = this.dataset.autoplay || false;
    if (!autoplay || this.container) return;

    const videoType = this.video.nodeName === 'VIDEO' ? 'video' : 'iframe';
    const videoHost = this.video.nodeName === 'VIDEO' ? 'shopify' : (this.video.src.includes('youtube') ? 'youtube' : 'vimeo');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (videoType == 'video') {
            this.video.play();
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"play"}', '*');
          }
        } else {
          if (videoType == 'video') {
            this.video.pause()
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    } , { threshold: 0.5 });

    observer.observe(this.video);
  }

  attachClickListener(videoContainer) {
    if (!videoContainer) return;
    videoContainer.addEventListener('click', (e) => {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    });

    this.video.onplay = () => {
      videoContainer.querySelector('button').hidden = true;
    }

    this.video.onpause = () => {
      videoContainer.querySelector('button').hidden = false;
    }
  }

  onVideoLoad() {
    // force youtube to play on mobile
    this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }
}
customElements.define('superpowered-video', SuperPoweredVideo);

// Gridy Slider - a custom Woolman built slider.
// Usage: <gridy-slider>
class GridySlider extends HTMLElement {
  constructor() {
    super();
    this.isHovered = false; // Initialize hover state
    this.init();
  }

  init() {
    this.sectionIndex = this.getAttribute('data-section-index');
    this.track = this.querySelector('.gridy-track');
    this.slides = this.querySelectorAll('.gridy-track > *');
    this.progressBars = this.querySelectorAll('.progress-bar');
    this.arrows = this.querySelector('.gridy-arrows');

    const data_ipr_desktop = parseInt(this.dataset.iprDesktop, 10) || 1;
    const data_ipr_tablet = parseInt(this.dataset.iprTablet, 10) || data_ipr_desktop;
    const data_ipr_mobile = parseInt(this.dataset.iprMobile, 10) || 1;
    const data_init_scroll_to = this.dataset.initScrollTo;
    const data_autoplay = this.dataset.autoplay != undefined ? JSON.parse(this.dataset.autoplay) : false;
    const data_autoplay_delay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
    const data_is_thumbnails_slider = this.dataset.thumbnailsFor != undefined ? true : false;
    const data_indicator = this.dataset.indicator != undefined ? JSON.parse(this.dataset.indicator) : false;
    const data_indicator_style = this.dataset.indicatorStyle;
    const data_sliding_behavior = this.dataset.slidingBehavior;
    const data_thumbnail_slider = document.getElementById(`thumbnail-${this.id}`);
    const data_track_overflow_visible = this.dataset.overflowVisible != undefined ? true : false;
    const data_card_type = this.dataset.cardType != undefined ? this.dataset.cardType : false;

    this.config = {
      slide_count: this.slides.length,
      current_slide: 0,
      active_slide_offset: 0,

      ipr_desktop: data_ipr_desktop,
      ipr_tablet: data_ipr_tablet,
      ipr_mobile: data_ipr_mobile,
      breakpoint_tablet: 768,
      breakpoint_desktop: 1024,

      arrows: true,
      autoplay: data_autoplay || false,
      autoplay_delay: data_autoplay_delay,
      start_time: null,
      elapsed_time: 0,
      timer: null,

      is_thumbnails_slider: data_is_thumbnails_slider,
      thumbnails_for: undefined,
      thumbnail_slider: data_thumbnail_slider,

      indicator: data_indicator,
      indicator_style: data_indicator_style,
      track_overflow_visible: data_track_overflow_visible,
      sliding_behavior: data_sliding_behavior || 'all',
    };

    if (data_init_scroll_to != undefined) {
      this.scrollToSlideByID(data_init_scroll_to);
    }

    if (this.config.arrows) {
      this.buttons = this.querySelectorAll('[data-gridy-arrow]');
      this.handleArrowClick = this.onArrowClick.bind(this);

      this.buttons.forEach(arrowButton => {
        arrowButton.addEventListener('click', this.handleArrowClick);
      });
    }

    if (this.config.autoplay) {
      this.autoplayGridy();
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.addEventListener('touchstart', this.onMouseEnter.bind(this));
      this.addEventListener('touchend', this.onMouseLeave.bind(this));
    }

    if (this.config.is_thumbnails_slider) {
      this.config.active_slide_offset = 2;
      this.config.thumbnails_for = document.getElementById(this.dataset.thumbnailsFor);
      this.thumbnail = this.querySelectorAll('[data-thumbnail-btn]');
      this.thumbnail.forEach(thumbnail => {
        thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
      });
    }

    if (this.config.indicator) {
      this.indicator_elements = this.querySelectorAll(`[data-indicator-${this.config.indicator_style}]`);
      this.indicator_current = this.querySelector('[data-indicator-current]');

      this.indicator_elements.forEach(indicator => {
        indicator.addEventListener('click', this.onIndicatorClick.bind(this));
      });
    }

    if (!this.config.is_thumbnails_slider) {
      let scrollTimeout;
      this.track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(this.afterScrollStops.bind(this), 0);
      });
    }

    if (data_card_type && data_card_type == 'traditional') {
      window.addEventListener('resize', this.adjustArrowsPosition.bind(this));
      this.adjustArrowsPosition();
    }
  }

  onMouseEnter() {
    this.isHovered = true;
    this.clearAutoplayTimer();
  }

  onMouseLeave() {
    this.isHovered = false;
    this.autoplayGridy();
  }

  reset(scrollToFirstSlide = true) {
    if (this.config.autoplay && this.config.timer) {
      this.clearAutoplayTimer();
    }

    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.removeEventListener('touchstart', this.onMouseEnter);
    this.removeEventListener('touchend', this.onMouseLeave);
    this.track.removeEventListener('scroll', this.afterScrollStops);

    if (this.config.arrows) {
      this.buttons.forEach(arrowButton => {
        arrowButton.removeEventListener('click', this.handleArrowClick);
      });
    }

    scrollToFirstSlide && this.scrollToSlide(0);

    this.slides.forEach(item => {
      item.classList.remove('active');
    });

    this.track = null;
    this.slides = null;
    this.buttons = null;
    this.thumbnail = null;
    this.indicator_elements = null;
    this.indicator_current = null;

    this.init();
  }

  afterScrollStops() {
    let slideInView = this.firstSlideInView();
    this.config.current_slide = slideInView;
    this.setActiveSlide(this.slides[slideInView + this.config.active_slide_offset]);

    if (this.config.thumbnail_slider) {
      this.config.thumbnail_slider.scrollToSlide(slideInView);
    }

    if (this.sectionIndex && parseInt(this.sectionIndex) == 1) {
      const slideChangeEvent = new CustomEvent('gridy-slider:slide-change', {
        detail: {
          element: this,
          currentSlide: slideInView + this.config.active_slide_offset,
          slideElement: this.slides[slideInView + this.config.active_slide_offset]
        }
      });

      document.dispatchEvent(slideChangeEvent);
    }
  }

  updateProgressBar() {
    this.progressBars.forEach((progressBar, index) => {
      if (index === this.config.current_slide && this.config.timer) {
        progressBar.classList.add('active');
        const elapsedTime = Date.now() - this.config.start_time + this.config.elapsed_time;
        const elapsedPercentage = (elapsedTime / this.config.autoplay_delay) * 100;

        progressBar.style.setProperty('--progress-width', `${elapsedPercentage}%`);
        progressBar.style.setProperty('--autoplay-delay', `${this.config.autoplay_delay - this.config.elapsed_time}ms`);
      }
    });
  }
  
  resetProgressBar() {
    this.config.start_time = Date.now();
    this.config.elapsed_time = 0;

    this.progressBars.forEach((progressBar) => {
      progressBar.classList.remove('active');
      progressBar.style.setProperty('--progress-width', '0%');
    });
  }

  autoplayGridy() {
    if (this.isHovered) return; // Do not start autoplay if hovered

    this.config.start_time = Date.now();

    this.config.updateInterval = setInterval(() => {
      this.updateProgressBar();
    }, 10);

    this.config.timer = setTimeout(() => {
      this.scrollByIPR('next');
    }, this.config.autoplay_delay - this.config.elapsed_time);
  }

  pauseAutoplayTimer() {
    clearTimeout(this.config.timer);
    clearInterval(this.config.updateInterval);
    this.config.timer = null;
    this.config.elapsed_time += Date.now() - this.config.start_time;
  }

  clearAutoplayTimer() {
    this.pauseAutoplayTimer();
  }

  onThumbnailClick(event) {
    event.preventDefault();
    this.config.current_slide = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
    this.config.thumbnails_for.scrollToSlideByID(event.currentTarget.dataset.itemId);
    this.scrollToSlide(this.config.current_slide);
  }

  onIndicatorClick(event) {
    event.preventDefault();

    if (!event.currentTarget.dataset.slideTo) return;

    this.scrollToSlide(parseInt(event.currentTarget.dataset.slideTo));
  }

  onArrowClick(event) {
    this.scrollByIPR(event.currentTarget.dataset.direction);
  }

  scrollByIPR(direction) {
    let currentIPR = this.getCurrentIPR(),
      slideMultiplier = this.config.sliding_behavior == 'all' ? currentIPR : 1,
      newCurrentSlide = this.config.current_slide,
      lastToShow = this.config.slide_count - currentIPR;

    /* 
      Used to check the next visible slide. If the next slide is not visible, it will skip to the next visible slide.
      This is used on PDP where we render all the images, but show only the images of the selected variant.
    */
    const isSlideVisible = index => {
      const slide = this.slides[index];
      return slide && window.getComputedStyle(slide).display !== 'none';
    };

    if (direction === 'next') {
      for (let i = 0; i < slideMultiplier; i++) {
        newCurrentSlide++;
        if (newCurrentSlide > lastToShow) {
          newCurrentSlide = 0;
        }
        while (!isSlideVisible(newCurrentSlide)) {
          newCurrentSlide++;
          if (newCurrentSlide > lastToShow) {
            newCurrentSlide = 0;
          }
        }
      }
    } else if (direction === 'prev') {
      for (let i = 0; i < slideMultiplier; i++) {
        newCurrentSlide--;
        if (newCurrentSlide < 0) {
          newCurrentSlide = lastToShow;
        }
        while (!isSlideVisible(newCurrentSlide)) {
          newCurrentSlide--;
          if (newCurrentSlide < 0) {
            newCurrentSlide = lastToShow;
          }
        }
      }
    }

    this.config.current_slide = newCurrentSlide;
    this.scrollToSlide(newCurrentSlide);
  }

  scrollToSlide(newPosition) {
    if (isNaN(newPosition)) {
      return;
    }

    let slidePosWithOffset = newPosition - this.config.active_slide_offset,
      newScrollToSlidePos = slidePosWithOffset > 0 ? slidePosWithOffset : 0;

    const slideInNewScrollToPos = this.slides[newScrollToSlidePos];

    if (!slideInNewScrollToPos) return;

    let scrollToLeft = slideInNewScrollToPos.offsetLeft,
      scrollToTop = slideInNewScrollToPos.offsetTop;

    if (this.config.track_overflow_visible) {
      scrollToLeft = this.slides[newScrollToSlidePos].offsetLeft - this.slides[0].offsetLeft;
    }

    this.track.scrollTo({
      left: scrollToLeft,
      top: scrollToTop,
      behavior: 'smooth',
    });

    this.slides.forEach(item => {
      item.classList.remove('active');
    });

    this.slides[newPosition].classList.add('active');

    this.config.current_slide = newPosition;
    this.setActiveSlide(this.slides[newPosition]);

    if (this.sectionIndex && parseInt(this.sectionIndex) == 1) {
      const slideChangeEvent = new CustomEvent('gridy-slider:slide-change', {
        detail: {
          element: this,
          currentSlide: newPosition,
          slideElement: this.slides[newPosition]
        }
      });

      document.dispatchEvent(slideChangeEvent);
    }
  }

  scrollToSlideByID(slideID) {
    const theSlide = document.getElementById(slideID),
      newPosition = Array.from(theSlide.parentNode.children).indexOf(theSlide);
    this.scrollToSlide(newPosition);
  }

  setActiveSlide(slide) {
    this.slides.forEach(item => {
      item.classList.remove('active');
    });

    slide.classList.add('active');

    if (this.config.indicator) {
      if (this.indicator_current) {
        this.indicator_current.textContent = this.config.current_slide + 1;
      }

      if (this.indicator_elements) {
        this.indicator_elements.forEach(dot => {
          dot.classList.remove('active');
        });

        if (this.indicator_elements[this.config.current_slide]) {
          this.indicator_elements[this.config.current_slide].classList.add('active');
        }
      }
    }

    if (this.config.autoplay) {
      this.resetProgressBar();
      this.clearAutoplayTimer();
      this.autoplayGridy();
    }
  }

  getCurrentIPR() {
    let currentIPR = this.config.ipr_mobile;
    if (woolman_window_size >= this.config.breakpoint_desktop) {
      currentIPR = this.config.ipr_desktop;
    } else if (woolman_window_size >= this.config.breakpoint_tablet) {
      currentIPR = this.config.ipr_tablet;
    }
    return currentIPR;
  }

  firstSlideInView() {
    let loopIndex = 0;
    for (const slide of this.slides) {
      if (this.isSlideInView(slide)) {
        return loopIndex;
      }
      ++loopIndex;
    }
    return this.config.current_slide;
  }

  isSlideInView(slide) {
    const containerBounds = this.track.getBoundingClientRect();
    const slideBounds = slide.getBoundingClientRect();

    const isSlideVisible =
      Math.round(slideBounds.top) >= Math.floor(containerBounds.top) &&
      Math.floor(slideBounds.bottom) <= Math.round(containerBounds.bottom) &&
      Math.round(slideBounds.left) >= Math.floor(containerBounds.left) &&
      Math.floor(slideBounds.right) <= Math.round(containerBounds.right) &&
      window.getComputedStyle(slide).display !== 'none';

    return isSlideVisible;
  }

  adjustArrowsPosition() {
    const firstMediaItem = this.querySelector('.card-media');

    if (!firstMediaItem) return;

    const height = firstMediaItem.offsetHeight;

    this.arrows.style.top = `${height / 2}px`;
  }
}

customElements.define('gridy-slider', GridySlider);

// QuantityInput for + and - button functionality
// Used in: cart items, upsell items
class QuantityInput extends HTMLElement {
  constructor() {
    super();

    if (this.getAttribute('disabled') === 'true') {
      return;
    }
    
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);

class ProductCard extends HTMLElement {
  static get observedAttributes() {
    return ['variant-id'];
  }

  constructor() {
    super();
    this.handle = this.getAttribute('handle');

    if (!this.handle) return;

    this.productImages = this.querySelectorAll('.card-media-item');
    this.priceElement = this.querySelector('.card-price');
    this.actionsElement = this.querySelector('.card-actions');
    this.badgesElements = this.querySelectorAll('.badges');
    this.compareAtPriceElement = this.querySelector('.compare-at-price');
    this.currentVariantNameElement = this.querySelector('[data-current-variant-name]');
    this.json = this.querySelector('[type="application/json"]') && JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.currentVariant = this.json.find(variant => variant.id === parseInt(this.getAttribute('variant-id')));
    this.productPageLinks = this.querySelectorAll('a[href*="/products/"]');
    this.context = this.getAttribute('context');

    this.swatchesContainer = this.querySelector('.swatches');
    this.swatches = this.querySelectorAll('.swatch');
    this.moreSwatches = this.querySelector('.swatch-more');

    this.swatches.forEach(button => button.addEventListener('click', this.onSwatchClick.bind(this)));
  }

  connectedCallback() {
    this.updateSwatches();
    document.addEventListener('estrid:resize', this.updateSwatches.bind(this));
    document.addEventListener('estrid:layout-changed', this.updateSwatches.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('estrid:resize', this.updateSwatches.bind(this));
    document.removeEventListener('estrid:layout-changed', this.updateSwatches.bind(this));
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'variant-id' && oldValue !== newValue) {
      const quickBuyElement = this.querySelector('quick-buy');
      if (quickBuyElement && oldValue != null) {
        quickBuyElement.updateVariant(newValue);
      }
    }
  }

  updateSwatches() {
    if (!this.swatchesContainer || !this.swatches || !this.moreSwatches || this.swatchesContainer.classList.contains('show-all')) {
      return;
    }

    let containerWidth = this.swatchesContainer.offsetWidth;
    let totalWidth = this.swatches[0].offsetWidth;
    let hiddenCount = 0;

    this.swatches.forEach(swatch => swatch.parentElement.style.display = 'flex');

    this.swatches.forEach((swatch, index) => {
      totalWidth += swatch.offsetWidth + 5;

      if (totalWidth > containerWidth) {
        swatch.parentElement.style.display = 'none';
        hiddenCount++;
      }
    });

    if (hiddenCount > 0) {
      this.moreSwatches.style.display = 'flex';
      this.moreSwatches.textContent = `+${hiddenCount}`;
    } else {
      this.moreSwatches.style.display = 'none';
    }
  }

  async onSwatchClick(event) {
    event.preventDefault();

    const clickedSwatch = event.currentTarget;
    const variantId = clickedSwatch.getAttribute('data-variant-id');

    if (parseInt(variantId) === this.currentVariant.id) {
      return;
    }

    this.currentVariant = this.json.find(variant => variant.id === parseInt(variantId));
    this.setAttribute('variant-id', variantId);

    if (!this.currentVariant) return;

    this.swatches.forEach(swatch => swatch.classList.remove('active'));
    clickedSwatch.classList.add('active');

    this.toggleProductImages(variantId);
    this.updateAvailability(variantId);
    this.updateCurrentVariantName();

    try {
      const productInfo = await this.fetchProductInfo(variantId);
      this.updatePrice(productInfo);
      this.updateActions(productInfo);
      this.updateBadges(productInfo);
      this.updateProductPageLinks(variantId);
    } catch (error) {
      console.error("Error fetching product info:", error);
    }
  }

  toggleProductImages(variantId) {
    this.productImages.forEach(image => {
      const isVisible = image.getAttribute('data-variant-id') === variantId;
      image.style.display = isVisible ? 'block' : 'none';
    });
  }

  async fetchProductInfo(variantId) {
    const rootUrl = window.routes.root === '/' ? '/' : `${window.routes.root}/`;

    let productUrl;
    
    if (this.context === 'cart-recommendations') {
      productUrl = `${rootUrl}products/${this.handle}?view=ajax-card-cart&variant=${variantId}`;
    } else {
      productUrl = `${rootUrl}products/${this.handle}?view=ajax-card&variant=${variantId}`;
    }

    try {
      const response = await fetch(productUrl);

      if (!response.ok) {
        throw new Error(`Failed to fetch product info: ${response.statusText}`);
      }

      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");

      return html;
    } catch (error) {
      throw new Error(`Error fetching product info: ${error.message}`);
    }
  }

  updatePrice(html) {
    const priceHtml = html.querySelector('.card-price');

    if (priceHtml) {
      this.priceElement.innerHTML = priceHtml.innerHTML;
    }
  }

  updateBadges(html) {
    const badgesHtmlCollection = html.querySelectorAll('.badges');
  
    if (badgesHtmlCollection.length > 0) {
      const badgeHtmlContent = badgesHtmlCollection[0].innerHTML;
  
      this.badgesElements.forEach((badgeElement) => {
        badgeElement.innerHTML = badgeHtmlContent;
      });
    }
  }

  updateAvailability(variantId) {
    const { available } = this.currentVariant;
    this.classList.toggle('sold-out', !available);
  }

  updateProductPageLinks(variantId) {
    this.productPageLinks = this.querySelectorAll('a[href*="/products/"]');

    if (this.productPageLinks) {
      this.productPageLinks.forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variantId);
        link.href = url.toString();
      });
    }
  }

  updateActions(html) {
    if (this.context == 'starter-kit') return;
    const cardActionsHtml = html.querySelector('.card-actions');
    if (cardActionsHtml) {
      while (this.actionsElement.firstChild) {
        if(this.actionsElement.firstChild?.classList?.contains("upsell-quickadd") && this.actionsElement.firstChild.nodeType === Node.ELEMENT_NODE){
          break;
        }
        this.actionsElement.removeChild(this.actionsElement.firstChild);
      }
      Array.from(cardActionsHtml.children).forEach(child => {
        if(this.actionsElement.firstChild?.classList?.contains("upsell-quickadd") && this.actionsElement.firstChild.nodeType === Node.ELEMENT_NODE){
          return;
        }
        this.actionsElement.appendChild(child.cloneNode(true));
      });
    }
  }

  updateCurrentVariantName() {
    if (!this.currentVariantNameElement) return;

    this.currentVariantNameElement.textContent = this.currentVariant.title;
  }
}

customElements.define('product-card', ProductCard);

